// ReactJS
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import SubDomains from '../../components/SubDomains';

// Modules
import { setStoreData } from '../../modules/common';

// Services
import { getStoreService } from '../../services/store';
import LimitedFreemiumPlan from '../../components/LimitedFreemiumPlan';

const DomainPage = ({ storeId, storeData, setStoreData }) => {
    const [data, setData] = useState({});

    useEffect(() => {
        setData(storeId);
        getStoreService(storeId)
            .then(({ data }) => {
                // Save store data in redux
                setStoreData(data);
            })
            .catch((err) => console.log(err));
    }, [storeId]);

    return (
        <>
            {storeData.plan_features.is_custom_domain_enabled === false && (
                <div
                    style={{
                        backgroundColor: '#f9fafb',
                        borderRadius: '10px',
                        padding: '16px',
                        margin: '8px 0',
                        fontFamily: 'Arial, sans-serif',
                    }}
                >
                    <label
                        style={{
                            display: 'block',
                            color: '#4b5563',
                            fontSize: '14px',
                            marginBottom: '6px',
                        }}
                    >
                        Tu tienda actual:
                    </label>
                    <div
                        style={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            padding: '10px 14px',
                            backgroundColor: 'white',
                            fontSize: '15px',
                            color: '#111827',
                        }}
                    >
                        {`https://${storeData.url}.ecometri.shop`}
                    </div>
                </div>
            )}

            <div style={{ position: 'relative' }}>
                <SubDomains storeId={data} storeData={storeData} setStoreData={setStoreData} />
                {storeData.plan_features.is_custom_domain_enabled === false && (
                    <LimitedFreemiumPlan type="domain" />
                )}
            </div>
        </>
    );
};

const mapStateToProps = ({ auth, common }) => ({
    storeId: auth.storeId,
    storeData: common.storeData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setStoreData,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DomainPage);
